import { ESortOrder } from '../../types/sortOrder';

/**
 * Проверяет и корректирует значение порядка сортировки
 * Значение должно входить в ESortOrder
 */
export const prepareSortOrder = (sortOrder: string | string[]) => {
  if (!sortOrder || !sortOrder.length) {
    return;
  }

  const sortOrderPrepared = (typeof sortOrder === 'string' ? sortOrder : sortOrder[0]).toLowerCase();

  if (!(Object.values(ESortOrder) as string[]).includes(sortOrderPrepared)) {
    return;
  }

  return sortOrderPrepared as ESortOrder;
};
